import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vendorStatusName'
})
export class VendorStatusNamePipe implements PipeTransform {

  private map: Record<string, { label: string; class: string }> = {
    draft:        { label: 'Draft',                class: 'chip-vendor-draft' },
    unverified:   { label: 'Draft',                class: 'chip-vendor-unverified' },
    pending:  { label: 'Awaiting Approval',    class: 'chip-vendor-pending' },
    approved: { label: 'Awaiting Verification', class: 'chip-vendor-approved' },
    verified: { label: 'Verified',             class: 'chip-vendor-verified' },
  };

  transform(value: string, type: 'label' | 'class'): string {
    const key = (value ?? '').toLowerCase();
    return this.map[key]?.[type] ?? '';
  }

}
